<section class="product-products {{ scheme }}">
  @for (item of items; track item) {
    <ng-container class="product-flex-row">
      <div class="product-btn-container">
        <button
          class="button"
          (click)="pickOptions(item)"
          (disabled)="(item.stock_quantity === 0)"
          >
          {{ item.title
          }}{{ (item.stock_quantity === 0 && ' - OUT OF STOCK') || '' }}
        </button>
      </div>
    </ng-container>
  }
</section>
